import { type Theme } from "@gravity-ui/uikit";
import { atom } from "@reatom/framework";
import { withLocalStorage } from "@reatom/persist-web-storage";

export const themeAtom = atom<Theme>("system", "theme").pipe(
  withLocalStorage("theme"),
);
